import type { Bookmark } from "metabase-types/api";

import { appendSlug, slugify } from "./utils";

export function bookmark(bm: Bookmark) {
  const basePath = bm.type === "card" ? (bm.card_type ?? "question") : bm.type;
  const itemPath = appendSlug(bm.item_id, slugify(bm.name));
  return `/${basePath}/${itemPath}`;
}
